import { IconPlus } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useProfileSelectorContext } from '@/contexts/ProfileSelectorContext';
import { useProfiles, useSelectedProfile, useHasProfiles, useDefaultProfileId, useProfileStore, useProfileError } from '@/store/profileStore';
import { useProfileSelector } from '@/hooks/profile/useProfileSelector';
import { ProfileSelectorItem } from './ProfileSelectorItem';
import { ProfileSelectorLoading, ProfileSelectorEmpty, ProfileSelectorError } from './states';
import { createServiceVendorId } from '@/services/api/petseo.client.wrapper';

export function ProfileSelectorDropdown() {
  const { isOpen, setIsOpen, onSelectProfile } = useProfileSelectorContext();
  const { isLoading, isError } = useProfileSelector();
  const profileError = useProfileError();
  const profiles = useProfiles();
  const selectedProfile = useSelectedProfile();
  const hasProfiles = useHasProfiles();
  const defaultProfileId = useDefaultProfileId();
  const setDefaultProfileId = useProfileStore((s) => s.setDefaultProfileId);

  if (!isOpen) return null;

  return (
    <div
      className="dropdown-menu show"
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        minWidth: '380px',
        maxHeight: '300px',
        overflowY: 'auto',
        marginTop: '4px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
        zIndex: 1050,
      }}>
      <div className="dropdown-header text-uppercase small fw-medium">Twoje profile</div>

      {isLoading ? (
        <ProfileSelectorLoading />
      ) : isError || profileError ? (
        <ProfileSelectorError />
      ) : profiles.length === 0 ? (
        <ProfileSelectorEmpty onClose={() => setIsOpen(false)} />
      ) : (
        profiles.map((profile) => (
          <ProfileSelectorItem
            key={String(profile.id)}
            profile={profile}
            isSelected={profile.id === selectedProfile?.id}
            isDefault={profile.id === String(defaultProfileId)}
            onSelect={() => profile.id && onSelectProfile(createServiceVendorId(profile.id))}
            onToggleDefault={() => profile.id && setDefaultProfileId(createServiceVendorId(profile.id))}
          />
        ))
      )}

      {hasProfiles && (
        <>
          <div className="dropdown-divider" />
          <Link to="/profiles/add" className="dropdown-item d-flex align-items-center gap-2" onClick={() => setIsOpen(false)}>
            <IconPlus size={18} className="text-secondary" />
            <span>Dodaj nowy profil</span>
          </Link>
        </>
      )}
    </div>
  );
}
